import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  AppBar,
  Toolbar,
  IconButton
} from '@mui/material'
import {
  Restaurant,
  ArrowBack,
  Save,
  Person
} from '@mui/icons-material'
import { useAuth } from '../../contexts/AuthContext'
import api from '../../utils/axios'

const ProdutorPerfil = () => {
  const navigate = useNavigate()
  const { user, updateUser } = useAuth()
  console.log(user);
  const { register, handleSubmit, formState: { errors } } = useForm({
    defaultValues: {
      nome: user?.nome || '',
      cpf: user?.cpf || '',
      caf: user?.caf || '',
      data_inscricao_caf: user?.data_inscricao_caf || ''
      // data_inscricao_caf: user?.data_inscricao_caf
      //   ? new Date(user.data_inscricao_caf).toISOString().split('T')[0]
      //   : ''
    }
  })
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const [loading, setLoading] = useState(false)

  const onSubmit = async (data) => {
    setError('')
    setSuccess('')
    setLoading(true)

    console.log(data);
    

    try {
      const response = await api.put('/produtor/update.php', {
        id: user.id,
        nome: data.nome,
        cpf: data.cpf,
        caf: data.caf,
        data_inscricao_caf: data.data_inscricao_caf
      })

      if (response.data.success) {
        const updatedUser = { ...user, ...data }
        updateUser(updatedUser)
        setSuccess('Dados atualizados com sucesso!')
        setTimeout(() => {
          navigate('/produtor')
        }, 1500)
      } else {
        setError(response.data.message || 'Erro ao atualizar dados')
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Erro ao atualizar dados')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => navigate('/produtor')}
            sx={{ mr: 2 }}
          >
            <ArrowBack />
          </IconButton>
          <Person sx={{ mr: 2 }} />
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Meu Perfil
          </Typography>
        </Toolbar>
      </AppBar>

      <Container maxWidth="sm" sx={{ py: 3 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <Person sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
            <Typography variant="h5" gutterBottom>
              Atualizar Dados Cadastrais
            </Typography>
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
              {error}
            </Alert>
          )}

          {success && (
            <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess('')}>
              {success}
            </Alert>
          )}

          <form onSubmit={handleSubmit(onSubmit)}>
            <TextField
              fullWidth
              label="Nome Completo"
              margin="normal"
              {...register('nome', {
                required: 'Nome é obrigatório',
                minLength: {
                  value: 3,
                  message: 'Nome deve ter no mínimo 3 caracteres'
                }
              })}
              error={!!errors.nome}
              helperText={errors.nome?.message}
            />

            <TextField
              fullWidth
              label="CPF"
              margin="normal"
              {...register('cpf', {
                required: 'CPF é obrigatório',
                pattern: {
                  value: /^\d{11}$/,
                  message: 'CPF deve conter 11 dígitos'
                }
              })}
              error={!!errors.cpf}
              helperText={errors.cpf?.message}
              placeholder="00000000000"
            />

            <TextField
              fullWidth
              label="CAF (Cadastro da Agricultura Familiar)"
              margin="normal"
              {...register('caf', {
                required: 'CAF é obrigatório'
              })}
              error={!!errors.caf}
              helperText={errors.caf?.message}
            />

            <TextField
              fullWidth
              label="Data de Inscrição do CAF"
              type="date"
              margin="normal"
              InputLabelProps={{
                shrink: true
              }}
              {...register('data_inscricao_caf', {
                required: 'Data de inscrição do CAF é obrigatória'
              })}
              error={!!errors.data_inscricao_caf}
              helperText={
                errors.data_inscricao_caf?.message ||
                'Esta data deve ser atualizada a cada 3 anos'
              }
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              sx={{ mt: 3 }}
              startIcon={<Save />}
              disabled={loading}
            >
              {loading ? 'Salvando...' : 'Salvar Alterações'}
            </Button>
          </form>
        </Paper>
      </Container>
    </Box>
  )
}

export default ProdutorPerfil

